import { isElectronContext } from '../utils/isElectron';

let isElectron = isElectronContext();

let electron;
if (isElectron) {
  electron = window.require && window.require('electron');
}

export default [
  {
    path: '*',
    name: 'errorPage',
    component: () => import(/* webpackChunkName: "pageNotFound" */ '@/views/error/PageNotFound.vue'),
  },
  {
    name: 'index',
    path: '/',
    ...(isElectron
      ? {
          redirect: {
            name: 'sports.games',
          },
        }
      : {
          component: () => import(/* webpackChunkName: "sports" */ '@/views/Index.vue'),
        }),
  },
  {
    name: 'sports.props',
    path: '/props/sports/',
    component: () => import(/* webpackChunkName: "sports" */ '@/views/sports/Sports.vue'),
    children: [
      {
        name: 'sports.props.data',
        path: ':id?/:event?',
        component: () => import(/* webpackChunkName: "props" */ '@/views/sports/components/Props.vue'),
      },
    ],
  },
  {
    name: 'sports',
    path: '/sports',
    component: () => import(/* webpackChunkName: "sports" */ '@/views/sports/Sports.vue'),
    children: [
      {
        name: 'sports.games',
        path: '/',
        component: () => import(/* webpackChunkName: "games" */ '@/views/sports/components/Games.vue'),
        children: [
          {
            path: '*',
            component: () => import(/* webpackChunkName: "games" */ '@/views/sports/components/Games.vue'),
            name: 'C',
          },
        ],
      },
    ],
  },
  {
    name: 'bet-slip',
    path: '/bet-slip',
    component: () =>
      import(/* webpackChunkName: "BetSlipMobileWrapper" */ '@/views/sports/components/BetSlipMobileWrapper.vue'),
    meta: {
      footerDisabled: true,
    },
  },
  {
    name: 'login',
    path: '/login',
    component: () => import(/* webpackChunkName: "LoginView" */ '@/views/auth/LoginView.vue'),
  },
  {
    name: 'register',
    path: '/register',
    component: () => import(/* webpackChunkName: "RegisterView" */ '@/views/auth/RegisterView.vue'),
  },
  {
    name: 'forgot-password',
    path: '/forgot-password',
    component: () => import(/* webpackChunkName: "ForgotPasswordView" */ '@/views/auth/ForgotPasswordView.vue'),
  },
  {
    name: 'reset-password',
    path: '/reset-password',
    component: () => import(/* webpackChunkName: "ResetPasswordView" */ '@/views/auth/ResetPasswordView.vue'),
  },
  {
    name: 'my-account',
    path: '/my-account',
    component: () => import(/* webpackChunkName: "MyAccountView" */ '@/views/auth/MyAccountView.vue'),
  },
  {
    name: 'selfExclusion',
    path: '/self-exclusion',
    component: () => import(/* webpackChunkName: "SelfExclusion" */ '@/views/profile/pages/SelfExclusion'),
  },
  {
    name: 'contactPreferences',
    path: '/contact-preferences',
    component: () => import(/* webpackChunkName: "ContactPreferences" */ '@/views/profile/pages/ContactPreferences'),
  },
  {
    path: '/deposit',
    name: 'deposit',
    component: () => import(/* webpackChunkName: "DepositView" */ '@/views/deposit/DepositView.vue'),
    children: [
      {
        path: 'moneygram',
        component: () => import(/* webpackChunkName: "MoneyGramView" */ '@/views/deposit/MoneyGramView.vue'),
      },
      {
        path: 'credit-card',
        name: 'creditcard',
        meta: { isVisibleDeposit: true },
        component: () => import(/* webpackChunkName: "CreditCardView" */ '@/views/deposit/CreditCardView.vue'),
        meta: {
          depositEndpoint: '/creditcards',
        },
      },
      {
        path: 'echeck',
        component: () => import(/* webpackChunkName: "false" */ '@/views/deposit/ECheckView.vue'),
      },
      {
        path: 'pcwpf',
        component: () => import(/* webpackChunkName: "false" */ '@/views/deposit/Pcwpf.vue'),
        children: [
          {
            name: 'pcwpf-ok',
            path: 'ok',
            component: () => import(/* webpackChunkName: "false" */ '@/views/deposit/Pcwpf.vue'),
          },
          {
            name: 'pcwpf-no',
            path: 'no',
            component: () => import(/* webpackChunkName: "false" */ '@/views/deposit/Pcwpf.vue'),
          },
        ],
      },
      {
        path: 'crypto-currency/:key',
        component: () => import(/* webpackChunkName: "ECheckView" */ '@/views/deposit/CryptoCurrencyView.vue'),
      },
      {
        name: 'gameCash',
        path: 'cash',
        component: () => import(/* webpackChunkName: "ECheckView" */ '@/views/deposit/GameCashView.vue'),
      },
      {
        name: 'oxxo-pay',
        path: 'oxxo-pay',
        component: () => import(/* webpackChunkName: "OxxoPayView" */ '@/views/deposit/OxxoPayView.vue'),
      },
      {
        name: 'pix',
        path: 'pix',
        component: () => import(/* webpackChunkName: "PixView" */ '@/views/deposit/PixView.vue'),
      },
      {
        name: 'ewallet',
        path: 'ewallet/:key',
        component: () => import(/* webpackChunkName: "EwalletView" */ '@/views/deposit/Ewallet/EwalletView.vue'),
        meta: {
          depositEndpoint: '/stored/eWallet?processor={key}',
        },
      },
      {
        path: 'wire-transfer',
        component: () => import(/* webpackChunkName: "WireTransferView" */ '@/views/deposit/WireTransferView.vue'),
      },
      {
        path: 'online-banking',
        component: () => import(/* webpackChunkName: "OnlineBanking" */ '@/views/deposit/OnlineBanking.vue'),
      },
      {
        path: 'quickbit',
        component: () => import(/* webpackChunkName: "QUickBit" */ '@/views/deposit/QuickBitView.vue'),
      },
      {
        path: 'neteller',
        component: () => import(/* webpackChunkName: "Neteller" */ '@/views/deposit/NetellerView.vue'),
      },
      {
        path: 'skrill',
        component: () => import(/* webpackChunkName: "Neteller" */ '@/views/deposit/SkrillView.vue'),
      },
      {
        path: 'spei',
        name: 'spei',
        component: () => import(/* webpackChunkName: "SpeiView" */ '@/views/deposit/SpeiView.vue'),
      },
    ],
  },

  {
    name: 'quickbit-success',
    path: '/atm/cashier/deposit/quickbit/success',
    component: () => import(/* webpackChunkName: "ContactUsView" */ '@/views/deposit/QuicBitSuccessView'),
  },
  {
    name: 'skrill-declined',
    path: '/atm/cashier/deposit/skrill/declined',
    component: () => import(/* webpackChunkName: "ContactUsView" */ '@/views/deposit/SkrillDeclinedView'),
  },
  {
    name: 'skrill-success',
    path: '/atm/cashier/deposit/skrill/success',
    component: () => import(/* webpackChunkName: "ContactUsView" */ '@/views/deposit/SkrillSuccessView'),
  },

  {
    name: 'ewallet-declined',
    path: '/atm/cashier/deposit/ewallet/declined',
    component: () => import(/* webpackChunkName: "ewallet-declined" */ '@/views/deposit/EwalletDeclinedView'),
  },
  {
    name: 'ewallet-success',
    path: '/atm/cashier/deposit/ewallet/success',
    component: () => import(/* webpackChunkName: "ewallet-success" */ '@/views/deposit/EwalletSuccessView'),
  },
  {
    name: 'online-banking-declined',
    path: '/atm/cashier/deposit/online/banking/declined',
    component: () =>
      import(/* webpackChunkName: "online-banking-declined" */ '@/views/deposit/OnlineBankingDeclinedView'),
  },
  {
    name: 'online-banking-success',
    path: '/atm/cashier/deposit/online/banking/success',
    component: () =>
      import(/* webpackChunkName: "online-banking-success" */ '@/views/deposit/OnlineBankingSuccessView'),
  },

  {
    name: 'quickbit-declined',
    path: '/atm/cashier/deposit/quickbit/declined',
    component: () => import(/* webpackChunkName: "ContactUsView" */ '@/views/deposit/QuicBitDeclinedView'),
  },
  {
    path: '/cashier/cards',
    component: () => import(/* webpackChunkName: "DepositView" */ '@/views/deposit/DepositView.vue'),
    children: [
      // {
      //     path: 'credit-card-transaction',
      //     component: () =>
      //         import(/* webpackChunkName: "MoneyGramView" */ '@/views/deposit/CreditCardTransaction.vue'),
      // },
      {
        path: 'deposit-success',
        alias: 'credit-card-transaction',
        component: () => import(/* webpackChunkName: "CreditCardView" */ '@/views/deposit/DepositSuccess.vue'),
      },
    ],
  },
  {
    name: 'history',
    path: '/history',
    component: () => import(/* webpackChunkName: "HistoryView" */ '@/views/history/HistoryView.vue'),
  },
  {
    name: 'account-verification',
    path: '/account-verification',
    component: () =>
      import(/* webpackChunkName: "AccountVerification" */ '@/views/account-verification/AccountVerification.vue'),
  },
  {
    name: 'payout',
    path: '/payout',
    component: () => import(/* webpackChunkName: "PayoutView" */ '@/views/payout/PayoutView.vue'),
    children: [
      {
        name: 'echeckPayout',
        path: 'echeck',
        component: () => import(/* webpackChunkName: "ECheckPayoutView" */ '@/views/payout/ECheckView.vue'),
        meta: {
          payoutEndpoint: 'echeck',
        },
      },
      {
        path: 'crypto-currency/:key',
        component: () =>
          import(/* webpackChunkName: "CryptoCurrencyPayoutView" */ '@/views/payout/CryptoCurrencyView.vue'),
      },
      {
        name: 'wireTransferPayout',
        path: 'wire-transfer',
        component: () => import(/* webpackChunkName: "WireTransferPayoutView" */ '@/views/payout/WireTransferView.vue'),
        meta: {
          payoutEndpoint: 'wiretransfer',
          image: 'wire.png',
        },
      },
      {
        path: 'online-banking',
        component: () => import(/* webpackChunkName: "OnlineBankingPayoutView" */ '@/views/payout/OnlineBanking.vue'),
      },
      {
        path: 'skrill',
        component: () => import(/* webpackChunkName: "OnlineBankingPayoutView" */ '@/views/payout/SkrillView.vue'),
      },
      {
        path: 'neteller',
        component: () => import(/* webpackChunkName: "OnlineBankingPayoutView" */ '@/views/payout/NetellerView.vue'),
      },
      {
        path: 'payr',
        component: () => import(/* webpackChunkName: "OnlineBankingPayoutView" */ '@/views/payout/PayRPayoutView.vue'),
      },
      {
        path: 'pending',
        component: () => import(/* webpackChunkName: "PendingPayoutsView" */ '@/views/payout/PendingPayoutsView.vue'),
      },
      {
        path: 'spei',
        name: 'speiPayout',
        component: () => import(/* webpackChunkName: "PendingPayoutsView" */ '@/views/payout/SpeiPayoutView.vue'),
        meta: {
          payoutEndpoint: 'spei',
          image: 'spei.svg',
        },
      },
      {
        path: 'todito',
        name: 'toditoPayout',
        component: () => import(/* webpackChunkName: "ToditoPayoutView" */ '@/views/payout/ToditoPayoutView.vue'),
        meta: {
          payoutEndpoint: 'eWallet?processor=todito',
          image: 'Todito.png',
        },
      },
      {
        path: 'vcreditos',
        name: 'vcreditosPayout',
        component: () => import(/* webpackChunkName: "VcreditosPayoutView" */ '@/views/payout/VcreditosPayoutView.vue'),
        meta: {
          payoutEndpoint: 'eWallet?processor=vcreditos',
          image: 'Vcreditos.svg',
        },
      },
      {
        path: 'banktransfer',
        name: 'all4payPayout',
        component: () => import(/* webpackChunkName: "ToditoPayoutView" */ '@/views/payout/All4PayView.vue'),
        meta: {
          payoutEndpoint: 'all4pay',
        },
      },
    ],
  },
  {
    name: 'refer',
    path: '/refer',
    component: () => import(/* webpackChunkName: "ReferView" */ '@/views/landing/ReferView'),
  },
  {
    name: 'bonus',
    path: '/bonus',
    component: () => import(/* webpackChunkName: "BonusView" */ '@/views/landing/BonusView'),
  },
  {
    name: 'help',
    path: '/help',
    component: () => import(/* webpackChunkName: "HelpView" */ '@/views/landing/HelpView'),
  },
  {
    name: 'contact',
    path: '/contact',
    alias: '/contactenos',
    component: () => import(/* webpackChunkName: "ContactUsView" */ '@/views/landing/ContactUsView'),
  },
  //{
  // name: 'about',
  // path: '/about',
  // component: () => import( /* webpackChunkName: "AboutView" */ '@/views/landing/AboutView')
  // },
  (isElectron ? {
    path: '/clerk',
    component: () => import(/* webpackChunkName: "ClerkWrapper" */ '@/views/clerk/ClerkWrapper'),
    children: [
      {
        name: 'clerk-deposit',
        path: 'deposit',
        component: () => import(/* webpackChunkName: "ClerkDepositView" */ '@/views/clerk/ClerkDepositView'),
      },
      {
        name: 'clerk-ticket',
        path: 'ticket',
        component: () => import(/* webpackChunkName: "ClerkTicketView" */ '@/views/clerk/ClerkTicketView'),
      },
      {
        name: 'horse-ticket',
        path: 'horse-ticket',
        component: () => import(/* webpackChunkName: "HorseTicketView" */ '@/views/clerk/HorseTicketView'),
      },
      {
        name: 'clerk-ticket-deposit',
        path: 'ticket-deposit',
        component: () =>
          import(/* webpackChunkName: "ClerkTicketDepositView" */ '@/views/clerk/ClerkTicketDepositView'),
      },
      {
        name: 'clerk-wager',
        path: 'wager',
        component: () => import(/* webpackChunkName: "ClerkWagerView" */ '@/views/clerk/ClerkWagerView'),
      },
      {
        name: 'clerk-payout',
        path: 'payout',
        component: () => import(/* webpackChunkName: "ClerkPayout" */ '@/views/clerk/Payout/Payout.vue'),
      },
      {
        name: 'clerk-register-customer-payout',
        path: 'register-customer-payout',
        component: () =>
          import(
            /* webpackChunkName: "ClerkRegisterCustomerPayoutView" */ '@/views/clerk/ClerkRegisterCustomerPayoutView'
          ),
      },
      {
        name: 'clerk-loyalty',
        path: 'loyalty',
        component: () => import(/* webpackChunkName: "ClerkLoyaltyView" */ '@/views/clerk/ClerkLoyaltyView'),
      },
      {
        name: 'change-password',
        path: 'change-password',
        component: () => import(/* webpackChunkName: "ChangePassword" */ '@/views/clerk/ChangePassword'),
      },
    ],
  }: { path: '/clerk',}),
  {
    name: 'clerk-ticket-test',
    path: 'clerk-ticket-test',
    component: () => import(/* webpackChunkName: "ClerkTicketTestView" */ '@/views/clerk/ClerkTicketTestView'),
  },
  {
    path: '/racing',
    name: 'racing',
    component: () => import(/* webpackChunkName: "racing" */ '@/views/racing/Racing.vue'),
  },
  {
    name: 'casino',
    path: '/casino',
    component: () => import(/* webpackChunkName: "casino" */ '@/views/casino/Casino.vue'),
    children: [
      {
        name: 'casino.games',
        path: '/casino/:id',
        component: () => import(/* webpackChunkName: "casinogames" */ '@/views/casino/components/GamesArea.vue'),
      },
    ],
  },
  {
    name: 'about',
    path: '/about',
    component: () => import(/* webpackChunkName: "about" */ '@/views/wordpress/about.vue'),
  },
  // {
  //     name: 'limits',
  //     path: '/limits',
  //     component: () => import( /* webpackChunkName: "about" */ '@/views/limits/GlobalLimits.vue'),
  // },
  {
    name: 'terms-of-use',
    path: '/terms-of-use',
    component: () => import(/* webpackChunkName: "TermsOfUse" */ '@/views/wordpress/TermsOfUse'),
  },
  {
    name: 'p',
    path: '/p/:slug',
    component: () => import(/* webpackChunkName: "Static" */ '@/views/wordpress/pages'),
  },
  {
    name: 'wager-limits',
    path: '/wager-limits',
    component: () => import(/* webpackChunkName: "about" */ '@/views/wager-limits/wager-limits.vue'),
  },
  {
    name: 'satisfaction-survey',
    path: '/satisfaction-survey',
    component: () => import(/* webpackChunkName: "SatisfactionSurvey" */ '@/views/SatisfactionSurvey'),
  },
  {
    name: 'start',
    path: '/start',
    component: () => import(/* webpackChunkName: "Start" */ '@/views/splash/screen'),
  },
  {
    name: 'deposit-page',
    path: '/deposit-page',
    component: () => import(/* webpackChunkName: "Start" */ '@/views/wordpress/DepositPage'),
  },
  {
    name: 'customer-satisfaction-survey',
    path: '/customer-satisfaction-survey',
    component: () => import(/* webpackChunkName: "Start" */ '@/views/newsurvey/NewSurvey'),
  },
];
